import { EventEmitter, SimpleChanges } from '@angular/core';
import { BaseComponent } from '../../../shared/base.component';
import { SessionService } from '../../session/session.service';
import { SessionStorageService } from "ngx-webstorage";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CancelSessionDialogComponent } from '../../session/cancel-session-dialog/cancel-session-dialog.component';
import { JhiEventManager } from '../../../ng-jhipster/service';
import { Router } from "@angular/router";
import { SessionStatusManagerService } from '../../../core/session/session-status-manager.service';
import * as i0 from "@angular/core";
import * as i1 from "../../session/session.service";
import * as i2 from "../../../ng-jhipster/service";
import * as i3 from "@angular/router";
import * as i4 from "ngx-webstorage";
import * as i5 from "@ng-bootstrap/ng-bootstrap";
import * as i6 from "../../../core/session/session-status-manager.service";
import * as i7 from "@angular/common";
import * as i8 from "../../../ng-jhipster/language/jhi-translate.directive";
import * as i9 from "../../../shared/auth/has-any-authority.directive";
import * as i10 from "@angular/material/form-field";
import * as i11 from "@angular/material/input";
import * as i12 from "@angular/forms";
import * as i13 from "./search-upcoming.pipe";
import * as i14 from "@ngx-translate/core";
function UpcomingSessionsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelement(1, "h3", 3);
    i0.ɵɵelement(2, "p", 4);
    i0.ɵɵelementEnd();
} }
function UpcomingSessionsComponent_div_1_mat_form_field_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-form-field", 10);
    i0.ɵɵelementStart(1, "mat-label");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 11);
    i0.ɵɵlistener("ngModelChange", function UpcomingSessionsComponent_div_1_mat_form_field_2_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(2); return ctx_r4.searchKey = $event; });
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 3, "coachManagement.search"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(5, 5, "coachManagement.search"));
    i0.ɵɵproperty("ngModel", ctx_r2.searchKey);
} }
function UpcomingSessionsComponent_div_1_div_4__svg_svg_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 27);
    i0.ɵɵelement(1, "use", 28);
    i0.ɵɵelementEnd();
} }
function UpcomingSessionsComponent_div_1_div_4__svg_svg_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 29);
    i0.ɵɵelement(1, "use", 30);
    i0.ɵɵelementEnd();
} }
function UpcomingSessionsComponent_div_1_div_4_div_20_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵelementStart(1, "button", 32);
    i0.ɵɵlistener("click", function UpcomingSessionsComponent_div_1_div_4_div_20_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(3); return ctx_r16.goToSessionChat(ctx_r16.session); });
    i0.ɵɵelement(2, "span", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function UpcomingSessionsComponent_div_1_div_4_div_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div");
} }
function UpcomingSessionsComponent_div_1_div_4_div_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 34);
} }
function UpcomingSessionsComponent_div_1_div_4_div_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div");
} }
function UpcomingSessionsComponent_div_1_div_4_div_24_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelementStart(1, "div", 35, 36);
    i0.ɵɵelementStart(3, "a", 37);
    i0.ɵɵelement(4, "img", 38);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "ul", 39);
    i0.ɵɵelementStart(6, "li", 40);
    i0.ɵɵelementStart(7, "a", 41);
    i0.ɵɵlistener("click", function UpcomingSessionsComponent_div_1_div_4_div_24_Template_a_click_7_listener() { i0.ɵɵrestoreView(_r21); const s_r6 = i0.ɵɵnextContext().$implicit; const ctx_r19 = i0.ɵɵnextContext(2); return ctx_r19.onSessionSelectedForReschedule.emit(s_r6); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "li");
    i0.ɵɵelementStart(9, "a", 42);
    i0.ɵɵlistener("click", function UpcomingSessionsComponent_div_1_div_4_div_24_Template_a_click_9_listener() { i0.ɵɵrestoreView(_r21); const s_r6 = i0.ɵɵnextContext().$implicit; const ctx_r22 = i0.ɵɵnextContext(2); return ctx_r22.cancelSession(s_r6.id, "cancel"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function UpcomingSessionsComponent_div_1_div_4_hr_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "hr", 43);
} }
const _c0 = function (a0) { return { "background-color": a0 }; };
function UpcomingSessionsComponent_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 12);
    i0.ɵɵelementStart(2, "div", 13);
    i0.ɵɵlistener("click", function UpcomingSessionsComponent_div_1_div_4_Template_div_click_2_listener() { const restoredCtx = i0.ɵɵrestoreView(_r25); const s_r6 = restoredCtx.$implicit; const i_r7 = restoredCtx.index; const ctx_r24 = i0.ɵɵnextContext(2); return ctx_r24.emitItem(s_r6, i_r7); });
    i0.ɵɵelementStart(3, "div", 14);
    i0.ɵɵelementStart(4, "div", 15);
    i0.ɵɵelementStart(5, "span", 16);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "br");
    i0.ɵɵelementStart(9, "span", 17);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 18);
    i0.ɵɵelementStart(13, "span");
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(15, "br");
    i0.ɵɵtemplate(16, UpcomingSessionsComponent_div_1_div_4__svg_svg_16_Template, 2, 0, "svg", 19);
    i0.ɵɵtemplate(17, UpcomingSessionsComponent_div_1_div_4__svg_svg_17_Template, 2, 0, "svg", 20);
    i0.ɵɵelement(18, "span", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 22);
    i0.ɵɵtemplate(20, UpcomingSessionsComponent_div_1_div_4_div_20_Template, 3, 0, "div", 23);
    i0.ɵɵtemplate(21, UpcomingSessionsComponent_div_1_div_4_div_21_Template, 1, 0, "div", 24);
    i0.ɵɵtemplate(22, UpcomingSessionsComponent_div_1_div_4_div_22_Template, 1, 0, "div", 25);
    i0.ɵɵtemplate(23, UpcomingSessionsComponent_div_1_div_4_div_23_Template, 1, 0, "div", 24);
    i0.ɵɵtemplate(24, UpcomingSessionsComponent_div_1_div_4_div_24_Template, 10, 0, "div", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(25, UpcomingSessionsComponent_div_1_div_4_hr_25_Template, 1, 0, "hr", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const s_r6 = ctx.$implicit;
    const i_r7 = ctx.index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(19, _c0, ctx_r3.setBackgroundColor(i_r7)));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(7, 13, s_r6.sessionStartTime, "dd MMM"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(11, 16, s_r6.sessionStartTime, "HH:mm"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(s_r6.userLogin);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", s_r6.type === "text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", s_r6.type === "video");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("jhiTranslate", "sessionSchedule.paragraph." + s_r6.type);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", s_r6.active || s_r6.started);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !s_r6.future);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", s_r6.future);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !s_r6.future);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", s_r6.future);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !(ctx_r3.selectedRow === i_r7 || ctx_r3.selectedRow - 1 === i_r7 || i_r7 === ctx_r3.upcomingSessions.length - 1));
} }
const _c1 = function () { return ["ROLE_CUSTOMER_CARE", "ROLE_COACH"]; };
function UpcomingSessionsComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵtemplate(2, UpcomingSessionsComponent_div_1_mat_form_field_2_Template, 6, 7, "mat-form-field", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 8);
    i0.ɵɵtemplate(4, UpcomingSessionsComponent_div_1_div_4_Template, 26, 21, "div", 9);
    i0.ɵɵpipe(5, "searchSessions");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(5, _c1));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(5, 2, ctx_r1.upcomingSessions, ctx_r1.searchKey));
} }
const _c2 = function () { return []; };
export class UpcomingSessionsComponent extends BaseComponent {
    constructor(sessionService, eventManager, router, sessionStorage, modalService, sessionStatusManagerService) {
        super(sessionStorage, modalService);
        this.sessionService = sessionService;
        this.eventManager = eventManager;
        this.router = router;
        this.sessionStorage = sessionStorage;
        this.modalService = modalService;
        this.sessionStatusManagerService = sessionStatusManagerService;
        this.onSessionItemSelected = new EventEmitter();
        this.onPersistentSessionEmitted = new EventEmitter();
        this.onSessionSelectedForReschedule = new EventEmitter();
        this.selectedRow = 0;
        this.conversations = [];
    }
    ngOnInit() {
    }
    ngOnChanges(changes) {
        super.ngOnChanges(changes);
        this.getRecentSessions();
    }
    getRecentSessions() {
        this.sessionService.recentSessions().subscribe((res) => {
            this.sessions = res.body || [];
            this.endeds = this.sessions.filter(s => s.ended);
            this.session = this.sessionService.decideWhichSessionToDisplay(this.sessions, this.endeds);
            this.upcomingSessions = this.sessions
                .filter(s => s.future || s.active || s.started)
                .sort((a, b) => (a.sessionStartTime < b.sessionStartTime ? -1 : 1));
            this.sessionStatusManagerService.setSessions(this.sessions);
            this.emitPersistentItem(this.session);
        }, () => this.onError());
        this.sessionListModificationEventSubscription = this.eventManager.subscribe('sessionListModification', () => { this.getRecentSessions(); });
    }
    cancelSession(sessionId, type) {
        const modalRef = this.modalService.open(CancelSessionDialogComponent, { size: 'md', backdrop: 'static' });
        modalRef.componentInstance.sessionId = sessionId;
        modalRef.componentInstance.type = type;
    }
    onError() {
    }
    emitItem(item, index) {
        this.selectedRow = index;
        this.onSessionItemSelected.emit(item);
    }
    goToSessionChat(session) {
        this.sessionStatusManagerService.navigateToSession(session);
    }
    emitPersistentItem(item) {
        console.log("emitPersistentItem");
        console.log(item);
        this.onPersistentSessionEmitted.emit(item);
    }
    setBackgroundColor(index) {
        return this.selectedRow === index ? '#F8F7F2' : 'white';
    }
    ngOnDestroy() {
        if (this.sessionListModificationEventSubscription) {
            this.sessionListModificationEventSubscription.unsubscribe();
        }
    }
}
UpcomingSessionsComponent.ɵfac = function UpcomingSessionsComponent_Factory(t) { return new (t || UpcomingSessionsComponent)(i0.ɵɵdirectiveInject(i1.SessionService), i0.ɵɵdirectiveInject(i2.JhiEventManager), i0.ɵɵdirectiveInject(i3.Router), i0.ɵɵdirectiveInject(i4.SessionStorageService), i0.ɵɵdirectiveInject(i5.NgbModal), i0.ɵɵdirectiveInject(i6.SessionStatusManagerService)); };
UpcomingSessionsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: UpcomingSessionsComponent, selectors: [["upcoming-sessions"]], inputs: { newSession: "newSession" }, outputs: { onSessionItemSelected: "onSessionItemSelected", onPersistentSessionEmitted: "onPersistentSessionEmitted", onSessionSelectedForReschedule: "onSessionSelectedForReschedule" }, features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 2, vars: 4, consts: [["class", "text-center p-4 mt-5", 4, "ngIf"], ["class", "row m-0", "style", "overflow-y: scroll; background-color: white;", 4, "ngIf"], [1, "text-center", "p-4", "mt-5"], ["jhiTranslate", "inukaNgApp.conversationn.noCoachees"], ["jhiTranslate", "inukaNgApp.conversationn.onceClientBooks"], [1, "row", "m-0", 2, "overflow-y", "scroll", "background-color", "white"], [1, "card", "form-card", 2, "margin-bottom", "14px"], ["style", "width: 100%", "appearance", "outline", 4, "jhiHasAnyAuthority"], [2, "overflow-y", "scroll", "height", "auto", "width", "100%", "max-height", "630px", "min-height", "150px"], [4, "ngFor", "ngForOf"], ["appearance", "outline", 2, "width", "100%"], ["matInput", "", 3, "placeholder", "ngModel", "ngModelChange"], ["role", "button", 1, "list-group-item", 3, "ngStyle"], [1, "d-flex", "justify-content-between", 2, "padding-left", "10px", 3, "click"], [1, "d-flex", "justify-content-start"], [2, "text-align", "left", "margin-right", "20px"], [2, "font-weight", "bold", "color", "#0A4A3A"], [2, "color", "#8A9D98"], [2, "text-align", "left", "color", "#0A4A3A"], ["class", "chat-icon", 4, "ngIf"], ["class", "video-icon-dark", 4, "ngIf"], [2, "font-weight", "bold", 3, "jhiTranslate"], [1, "d-flex", "justify-content-end"], ["class", "d-flex align-items-center", 4, "ngIf"], [4, "ngIf"], ["style", "text-align: right;", 4, "ngIf"], ["style", "margin: 0!important;", 4, "ngIf"], [1, "chat-icon"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#chat-icon"], [1, "video-icon-dark"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#video-icon-dark"], [1, "d-flex", "align-items-center"], [1, "btn", "btn-primary", 2, "padding", "0!important", "min-width", "100px!important", 3, "click"], ["jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.joinNow"], [2, "text-align", "right"], ["ngbDropdown", "", 1, "d-inline-block"], ["dropdown", ""], ["href", "", "data-toggle", "dropdown", "aria-expanded", "true"], ["src", "../../../../../content/images/inuka/three-dots-icon.png", "alt", "three dots icon", 2, "margin-top", "8px"], [1, "dropdown-menu", "dropdown-menu-right"], [2, "padding-bottom", "10px"], ["jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.reschedule", 1, "upcoming-link", 3, "click"], ["jhiTranslate", "inukaNgApp.indexUser.sessionInfoCard.cancel", 2, "text-decoration", "none", 3, "click"], [2, "margin", "0!important"]], template: function UpcomingSessionsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, UpcomingSessionsComponent_div_0_Template, 3, 0, "div", 0);
        i0.ɵɵtemplate(1, UpcomingSessionsComponent_div_1_Template, 6, 6, "div", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.conversations === i0.ɵɵpureFunction0(2, _c2));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.conversations !== i0.ɵɵpureFunction0(3, _c2));
    } }, directives: [i7.NgIf, i8.JhiTranslateDirective, i9.HasAnyAuthorityDirective, i7.NgForOf, i10.MatFormField, i10.MatLabel, i11.MatInput, i12.DefaultValueAccessor, i12.NgControlStatus, i12.NgModel, i7.NgStyle, i5.NgbDropdown], pipes: [i13.FilterSessionsPipe, i14.TranslatePipe, i7.DatePipe], styles: ["mat-form-field[_ngcontent-%COMP%]{height:30px;width:auto}.upcoming-link[_ngcontent-%COMP%]{color:#000;text-decoration:none}#upcoming-sessions-anchor[_ngcontent-%COMP%]{text-transform:uppercase;color:#000 !important;border:none}.form-card[_ngcontent-%COMP%]{padding:20px}.mat-form-field-outline[_ngcontent-%COMP%]{border-radius:20px !important}.list-group-item[_ngcontent-%COMP%]{border:none !important}.chat-icon[_ngcontent-%COMP%]{width:16px;height:16px;margin-right:5px}.video-icon-dark[_ngcontent-%COMP%]{width:14px;height:10px;margin-right:5px}.dropdown-menu[_ngcontent-%COMP%]{border:none;border-radius:10px;padding:20px;box-shadow:0 10px 20px rgba(0,0,0,.13);min-width:130px !important}.dropdown-menu[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{font-weight:bold;color:#44a38b;font-family:Poppins,sans-serif}[_nghost-%COMP%]  .mat-radio-button, [_nghost-%COMP%]  .mat-form-field, [_nghost-%COMP%]  .mat-select{font-family:\"Open Sans\",sans-serif !important;font-size:16px !important}[_nghost-%COMP%]  .mat-radio-button.mat-accent .mat-radio-inner-circle, [_nghost-%COMP%]  .mat-radio-button.mat-accent .mat-radio-ripple .mat-ripple-element:not(.mat-radio-persistent-ripple), [_nghost-%COMP%]  .mat-radio-button.mat-accent.mat-radio-checked .mat-radio-persistent-ripple, [_nghost-%COMP%]  .mat-radio-button.mat-accent:active .mat-radio-persistent-ripple{background-color:#44a38d}[_nghost-%COMP%]  .mat-radio-button.mat-accent.mat-radio-checked .mat-radio-outer-circle, [_nghost-%COMP%]  .mat-radio-outer-circle{border-color:#44a38d}[_nghost-%COMP%]  .mat-form-field-infix{border-top-width:8px !important;padding-bottom:8px !important;padding-top:8px !important}[_nghost-%COMP%]  .mat-form-field-appearance-outline .mat-form-field-outline{color:#cce9e0 !important}[_nghost-%COMP%]  .mat-form-field-appearance-outline .mat-form-field-outline-thick{color:var(--main) !important}"] });
